'use strict';

import ActionCoRuService from './action-coru-service.js';
import ApiTokenService from './api-token.service.js';
import CacheService from './cache-service.js';
import ColumnDefinitionService from './column-definition-service.js';
import ConcurrencyTrackingService from './concurrency-tracking-service.js';
import ContentWidgetService from './content-widget-service.js';
import DataModelDescriptorService from './control-descriptor-service.js';
import DashboardWidgetDataService from './dashboard-data-service.js';
import DataModelService from './data-model-service.js';
import { DataQueryService } from './data-query-service.js';
import { FilterExpressionService } from './filter-expression-service.ts';
import { DataService } from './data-service.js';
import { DeepLinkingService } from './deep-linking-service.js';
import designerOpener from './designer-opener-service.js';
import LocalizationModeHelper from './dialog-localization-mode-helper.js';
import { DialogOpenerService } from './dialog-opener-service.js';
import { EmbeddedViewService } from './embedded-view-service.js';
import { EntityService } from './entity-service.ts';
import { ExternalServiceManager } from './external-service-manager.js';
import HelpService from './help-service.js';
import JournalService from './journal-service.js';
import HolidaysService from './mx-holidays-service.js';
import MixedActionHelper from './mx-mixed-action-helper.js';
import TranslationService from './mx-translation-service.js';
import ViewHelpService from './mx-view-help-service.js';

import BasePreprocessorFactory from './preprocessors/mx-base-preprocessor.js';
import StructurePreprocessorFactory from './preprocessors/ms-structure-preprocessor.js';
import ColumnDefinitionPreprocessorFactory from './preprocessors/mx-column-definition-preprocessor.js';
import DateRangePreprocessorFactory from './preprocessors/mx-date-range-preprocessor.js';
import QuickFilterPreprocessorFactory from './preprocessors/mx-quick-filter-preprocessor.js';
import ServiceRequestParamsPreprocessorFactory from './preprocessors/mx-service-request-params-preprocessor.js';
import SortingPreprocessorFactory from './preprocessors/mx-sorting-preprocessor.js';
import SortingGridPreprocessorFactory from './preprocessors/mx-sorting-grid-preprocessor.js';
import PagingPreprocessorFactory from './preprocessors/mx-paging-preprocessor.js';
import SearchPreprocessorFactory from './preprocessors/mx-search-preprocessor.js';
import GroupingPreprocessorFactory from './preprocessors/mx-grouping-preprocessor.js';
import ClientQueryExecutorFactory from './preprocessors/mx-client-query-executor.js';
import DataQueryExecutorFactory from './preprocessors/mx-data-query-executor.js';
import ODataQueryExecutorFactory from './preprocessors/mx-odata-query-executor.js';

import { SchemaService } from './schema-service';
import { SchemaServiceEnums } from './schema-service-enums.js';
import SearchQueryService from './search-query-service.js';
import { WidgetManager } from './widget-manager.js';
import WizardService from './wizard-service.js';
import StylesService from './mx-styles-service';
import { AgentTelemetryService } from './agent-telemetry-service';

angular
	.module('mx.SolutionBuilderAgent')
	.service('mx.SolutionBuilderAgent.ActionCoRuService', ActionCoRuService)
	.service('mx.SolutionBuilderAgent.ApiTokenService', ApiTokenService)
	.service('mx.SolutionBuilderAgent.CacheService', CacheService)
	.service('mx.SolutionBuilderAgent.mxColumnDefinitionService', ColumnDefinitionService)
	.service('mx.SolutionBuilderAgent.ConcurrencyTrackingService', ConcurrencyTrackingService)
	.service('mx.SolutionBuilderAgent.ContentWidgetService', ContentWidgetService)
	.service('mx.SolutionBuilderAgent.ControlDescriptorService', DataModelDescriptorService)
	.service('mx.SolutionBuilderAgent.DashboardWidgetDataService', DashboardWidgetDataService)
	.service('mx.SolutionBuilderAgent.DataModelService', DataModelService)
	.service('mx.SolutionBuilderAgent.DataQueryService', DataQueryService)
	.service('mx.SolutionBuilderAgent.FilterExpressionService', FilterExpressionService)
	.service('mx.SolutionBuilderAgent.DataService', DataService)
	.service('mx.SolutionBuilderAgent.DeepLinkingService', DeepLinkingService)
	.service('mx.SolutionBuilderAgent.designerOpener', designerOpener)
	.service('mx.SolutionBuilderAgent.mxLocalizationModeHelper', LocalizationModeHelper)
	.service('mx.SolutionBuilderAgent.DialogOpenerService', DialogOpenerService)
	.service('mx.SolutionBuilderAgent.EmbeddedViewService', EmbeddedViewService)
	.service('mx.SolutionBuilderAgent.EntityService', EntityService)
	.service('mx.SolutionBuilderAgent.ExternalServiceManager', ExternalServiceManager)
	.service('mx.SolutionBuilderAgent.HelpService', HelpService)
	.service('mx.SolutionBuilderAgent.JournalService', JournalService)
	.service('mx.SolutionBuilderAgent.HolidaysService', HolidaysService)
	.service('mx.SolutionBuilderAgent.MixedActionHelper', MixedActionHelper)
	.service('mx.SolutionBuilderAgent.TranslationService', TranslationService)
	.service('mx.SolutionBuilderAgent.ViewHelpService', ViewHelpService)

	.factory('mx.SolutionBuilderAgent.BasePreprocessor', BasePreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.StructurePreprocessor', StructurePreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.ColumnDefinitionPreprocessor', ColumnDefinitionPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.DateRangePreprocessor', DateRangePreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.QuickFilterPreprocessor', QuickFilterPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.ServiceRequestParamsPreprocessor', ServiceRequestParamsPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.SortingPreprocessor', SortingPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.SortingGridPreprocessor', SortingGridPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.PagingPreprocessor', PagingPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.SearchPreprocessor', SearchPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.GroupingPreprocessor', GroupingPreprocessorFactory)
	.factory('mx.SolutionBuilderAgent.ClientQueryExecutor', ClientQueryExecutorFactory)
	.factory('mx.SolutionBuilderAgent.DataQueryExecutor', DataQueryExecutorFactory)
	.factory('mx.SolutionBuilderAgent.ODataQueryExecutor', ODataQueryExecutorFactory)

	.service('mx.SolutionBuilderAgent.SchemaService', SchemaService)
	.service('mx.SolutionBuilderAgent.SchemaService.Enums', SchemaServiceEnums)
	.service('mx.SolutionBuilderAgent.SearchQueryService', SearchQueryService)
	.service('mx.SolutionBuilderAgent.WidgetManager', WidgetManager)
	.service('mx.SolutionBuilderAgent.WizardService', WizardService)
	.service('mx.SolutionBuilderAgent.StylesService', StylesService)
	.service('mx.SolutionBuilderAgent.AgentTelemetryService', AgentTelemetryService);
